import { render, staticRenderFns } from "./playVideoView.vue?vue&type=template&id=38be0d48&scoped=true"
import script from "./playVideoView.vue?vue&type=script&lang=js"
export * from "./playVideoView.vue?vue&type=script&lang=js"
import style0 from "./playVideoView.vue?vue&type=style&index=0&id=38be0d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be0d48",
  null
  
)

export default component.exports